
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum DomainAvailabilityStatus {
	Unknown = 0,
	Available = 1,
	Occupied = 2,
	Error = 3
}
export namespace DomainAvailabilityStatus {
	export function getKeys(): Map<DomainAvailabilityStatus, string> {
		return new Map([[0, 'Unknown'], [1, 'Available'], [2, 'Occupied'], [3, 'Error']]);
	}
}
